import { tv } from '@change/ds-utils';

export const toolbar = tv({
	base: 'flex',
	compoundVariants: [
		{
			class: 'gap-2',
			isMobile: true,
		},
		{
			class: 'justify-end gap-3 self-auto',
			isMobile: false,
		},
		{
			class: 'self-stretch',
			isMobile: true,
			buttonVariant: 'square',
		},
	],
	variants: {
		isMobile: {
			false: '',
			true: '',
		},
		buttonVariant: {
			default: '',
			square: '',
		},
	},
});
